import { createAction } from 'typesafe-actions';

import { ScreenActions } from '../constants/Screen';

interface SetSmallScreenUiPayload {
  isScreenSmall: boolean;
}

export const setSmallScreenUI = createAction(
  ScreenActions.SET_SMALL_SCREEN_UI,
  (isScreenSmall: boolean) => ({ isScreenSmall }),
)<SetSmallScreenUiPayload>();
export type SetSmallScreenUiAction = ReturnType<typeof setSmallScreenUI>;

interface SetCurrentScreenDimensionsPayload {
  screenWidth: $TSFixMe;
  screenHeight: $TSFixMe;
}

export const setCurrentScreenDimensions = createAction(
  ScreenActions.SET_CURRENT_SCREEN_DIMENSIONS,
  (screenWidth: $TSFixMe, screenHeight: $TSFixMe) => ({ screenWidth, screenHeight }),
)<SetCurrentScreenDimensionsPayload>();
export type SetCurrentScreenDimensionsAction = ReturnType<typeof setCurrentScreenDimensions>;
